import React from "react"
import autobind from "class-autobind"
import { Dialog, FlatButton, TextField, SelectField, MenuItem } from "material-ui"
import strings from "../../../localization/strings"
import { IBudgetUnitItem, IPosition, IUnitItem } from "../../../models"
import * as utils from "../../../helpers/utils"
import AccountStore from "../../../stores/AccountStore"
interface IProps {
    budgetUnits: IUnitItem[]
    handleAdd(budgetUnitPositionDefinition: IBudgetUnitItem): void
    handleClose(): void
}
interface IState {
    selectedBudgetUnit: IUnitItem
    errorSelectedBudgetUnit: string
    selectedPosition: IPosition
    errorSelectedPosition: string
    perUnitFactor: number
    errorPerUnitFactor: string
}

export default class AddScheduleBudgetUnitPositionDefinitionDialog extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            selectedBudgetUnit: null,
            errorSelectedBudgetUnit: "",
            selectedPosition: null,
            errorSelectedPosition: "",
            perUnitFactor: 1,
            errorPerUnitFactor: ""
        }
        autobind(this)
    }

    handleAdd() {
        if (!this.checkValidate()) return
        const budgetUnitPositionDefinition = {
            Id: utils.guid(),
            UnitId: this.state.selectedBudgetUnit.Id,
            UnitName: this.state.selectedBudgetUnit.Name,
            PositionBaseId: this.state.selectedPosition.BasePositionId,
            PositionName: this.state.selectedPosition.Name,
            PerUnitFactor: this.state.perUnitFactor
        } as IBudgetUnitItem
        this.props.handleAdd(budgetUnitPositionDefinition)
    }

    checkValidate() {
        let isValidate = true
        if (!this.state.selectedBudgetUnit) {
            this.setState({ errorSelectedBudgetUnit: strings.This_field_is_required })
            isValidate = false
        }
        else {
            this.setState({ errorSelectedBudgetUnit: "" })
        }

        if (!this.state.selectedPosition) {
            this.setState({ errorSelectedPosition: strings.This_field_is_required })
            isValidate = false
        }
        else {
            this.setState({ errorSelectedPosition: "" })
        }

        if (!this.state.perUnitFactor) {
            this.setState({ errorPerUnitFactor: strings.Input_valid_integer })
            isValidate = false
        }
        else {
            this.setState({ errorPerUnitFactor: "" })
        }
        return isValidate
    }

    render() {
        return (
            <Dialog
                open
                title={strings.Add_Budget_Unit_Position_Definition}
                titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
                actions={[
                    <FlatButton
                        label={strings.CANCEL}
                        secondary
                        onTouchTap={this.props.handleClose}
                    />,
                    <FlatButton
                        label={strings.Add}
                        primary
                        onTouchTap={this.handleAdd}
                    />
                ]}
            >
                <hr />
                <div style={{ paddingRight: 20, paddingLeft: 20 }}>
                    <div style={{ width: "100%", display: "grid" }}>
                        <div style={{ gridRow: 1, gridColumn: 1 }}>
                            <SelectField
                                floatingLabelText={strings.Unit}
                                value={this.state.selectedBudgetUnit}
                                onChange={(_e, _key, _unit) => this.setState({ selectedBudgetUnit: _unit }, () => this.checkValidate())}
                                underlineDisabledStyle={{ borderBottom: "1px solid #e0e0e0" }}
                                errorText={this.state.errorSelectedBudgetUnit}
                            >
                                {this.props.budgetUnits.map((budgetUnit, index) =>
                                    <MenuItem key={index} value={budgetUnit} primaryText={budgetUnit.Name} />
                                )}
                            </SelectField>
                        </div>
                        <div style={{ gridRow: 1, gridColumn: 2, marginLeft: 20 }}>
                            <SelectField
                                floatingLabelText={strings.Position}
                                value={this.state.selectedPosition}
                                onChange={(_e, _key, _unit) => this.setState({ selectedPosition: _unit }, () => this.checkValidate())}
                                underlineDisabledStyle={{ borderBottom: "1px solid #e0e0e0" }}
                                errorText={this.state.errorSelectedPosition}
                            >
                                {AccountStore.getCurrentAccount().PositionDefinitions.filter(i => i.Active).map((position, index) =>
                                    <MenuItem key={index} value={position} primaryText={position.Name} />
                                )}
                            </SelectField>
                        </div>
                        <div style={{ gridRow: 2, gridColumn: 1 }}>
                            <TextField
                                floatingLabelText={strings.Unit_Factor}
                                value={this.state.perUnitFactor}
                                type="number"
                                step={1}
                                inputStyle={{ appearance: "auto" }}
                                onChange={(e, value) => utils.validateDouble(value) && this.setState({ perUnitFactor: value })}
                                errorText={this.state.errorPerUnitFactor}
                            />
                        </div>

                    </div>
                </div>
            </Dialog>
        )
    }
}